import { ReactElement, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery } from '@apollo/client'

import { SelectTags } from 'components/v2/SelectTags'
import {
  IService,
  IMultiServiceAutocompleteBySegmentsProps
} from 'features/Services/components/MultiServiceAutocompleteBySegments/types'
import { GET_SERVICES_BY_SEGMENTS } from 'features/Services/queries-legacy'
import { GTServicesResponse } from 'gql/types.generated'

const messages = defineMessages({
  emptyMessage: {
    id: 'servicesBySegments.autocomplete.emptyMessage',
    defaultMessage: 'No services found'
  }
})

export const MultiServiceAutocompleteBySegments = ({
  onChange,
  segmentIds,
  ...props
}: IMultiServiceAutocompleteBySegmentsProps): ReactElement => {
  const intl = useIntl()

  const { data, refetch } = useQuery<{ servicesWithPagination: GTServicesResponse }>(GET_SERVICES_BY_SEGMENTS, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      segmentIds: segmentIds
    }
  })

  useEffect(() => {
    refetch()
  }, [])

  const handleChange = (values: IService[]): void => {
    onChange(values)
  }

  return (
    <SelectTags
      emptyMessage={intl.formatMessage(messages.emptyMessage)}
      onChange={handleChange}
      {...props}
      items={data?.servicesWithPagination.items || []}
      getTagLabel={({ code }: IService): string => code ?? ''}
    />
  )
}
